/**
 * Creature screens (GDD §4.5): «Облик» (the constructor) and the Animation Lab (`debug/animlab`, registered by the
 * creature feature — architecture §1, §8.2).
 *
 * - `creature/make` stays a stub until wave 2 (UI kit + router).
 * - `debug/animlab` is P2's; until it lands, its entry also serves the P1 creature lab: `?screen=creaturelab` (alias)
 *   mounts «Кунсткамера облика» (creatureLab.ts). P2: keep the `creaturelab` alias dispatch when replacing the stub.
 */
import type { Screen, ScreenContext, ScreenDef, ScreenParams } from '../../shared';
import { stubScreen } from '../../ui';
import { createCreatureLab, creatureLabParams } from './creatureLab';
import { atelierScreen } from './atelier';

const animlabStub = stubScreen({ id: 'debug/animlab', aliases: ['animlab', 'cliplab'], titleKey: 'creature.screen.animlab', needs3d: true, kind: 'debug' });

/** True when the debug entry asked for the creature lab (`?screen=creaturelab`, `?view=creaturelab` or `?lab=creature`). */
const wantsCreatureLab = (p: ScreenParams): boolean => p.screen === 'creaturelab' || p.view === 'creaturelab' || p.lab === 'creature';

const animlab: ScreenDef = {
  ...animlabStub,
  aliases: ['animlab', 'cliplab', 'creaturelab'],
  parseParams: creatureLabParams,
  create(ctx: ScreenContext, params: ScreenParams): Screen {
    // The router may start a route-less debug screen without the page query: merge it here (page < explicit params).
    const merged: ScreenParams = { ...creatureLabParams(new URLSearchParams(typeof location === 'undefined' ? '' : location.search)), ...params };
    return wantsCreatureLab(merged) ? createCreatureLab(ctx, merged) : animlabStub.create(ctx, params);
  },
};

export const creatureScreens: ScreenDef[] = [
  atelierScreen,
  animlab,
];
